import React, { Component } from 'react';
import { bool, func, number, string, } from 'prop-types';
import moment from 'moment';

import Select from 'react-select';

import cx from 'classnames';
import s from './TimeInput.css';


class TimeInput extends Component {
  static propTypes = {
    disabled: bool,
    id: string.isRequired,
    onChange: func,
    timeIncrement: number,
    value: number,
  };

  static defaultState = {
    timeInput: '',
    timeOfDaySelector: 'AM',
  };

  constructor(props) {
    super(props);

    this.selectOptions = [
      { value: 'AM', label: 'AM' },
      { value: 'PM', label: 'PM' },
    ];

    this.state = TimeInput.defaultState;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value === undefined || nextProps.value === null || nextProps.value < 0) {
      this.setState(TimeInput.defaultState);
    } else {
      const minutesSinceMidnight = nextProps.value;
      const time = this.convertFromMinutesSinceMidnight(minutesSinceMidnight);
      this.setState({
        timeInput: time.format('h:mm'),
        timeOfDaySelector: time.format('A'),
      });
    }
  }

  convertFromMinutesSinceMidnight = (minutesSinceMidnight) => {
    const hours = Math.floor(minutesSinceMidnight / 60);
    const minutes = minutesSinceMidnight % 60;
    return moment(hours.toString() + ':' + minutes.toString(), 'H:mm');
  };

  convertToMinutesSinceMidnight = (timeInput, timeOfDaySelector) => {
    const midnight = moment().startOf('day');
    const time = moment(timeInput + ':' + timeOfDaySelector, 'h:mmA');
    return time.diff(midnight, 'minutes');
  };

  isValidTime = value => value && moment(value, 'h:mm').isValid();

  adjustForTimeIncrement = (minutesSinceMidnight, timeIncrement) => {
    if (timeIncrement && minutesSinceMidnight % timeIncrement !== 0) {
      if (Math.floor(minutesSinceMidnight % timeIncrement) < Math.floor(timeIncrement / 2)) {
        return Math.floor(minutesSinceMidnight / timeIncrement) * timeIncrement;
      }
      return (Math.floor(minutesSinceMidnight / timeIncrement) + 1) * timeIncrement;
    }
    return minutesSinceMidnight;
  };

  handleTimeChange = event => this.setState({ timeInput: event.target.value });

  handleTimeBlur = event => {
    const timeInput = this.isValidTime(event.target.value) ? event.target.value : '12:00';

    const minutesSinceMidnight = this.convertToMinutesSinceMidnight(timeInput, this.state.timeOfDaySelector);
    const adjustedMinutesSinceMidnight = this.adjustForTimeIncrement(minutesSinceMidnight, this.props.timeIncrement);
    const updatedTimeObject = this.convertFromMinutesSinceMidnight(adjustedMinutesSinceMidnight);

    this.setState({
      timeInput: updatedTimeObject.format('h:mm'),
      timeOfDaySelector: updatedTimeObject.format('A'),
    });

    if (this.props.onChange) {
      this.props.onChange(adjustedMinutesSinceMidnight);
    }
  };

  handleTimeOfDayChange = value => {
    const timeInput = this.isValidTime(this.state.timeInput) ? this.state.timeInput : '12:00';

    this.setState({
      timeInput,
      timeOfDaySelector: value.value
    });

    if (this.props.onChange) {
      this.props.onChange(this.convertToMinutesSinceMidnight(this.state.timeInput, value.value));
    }
  };

  render() {
    return (
      <div className={s.component}>
        <input
          className={s.input}
          disabled={this.props.disabled}
          id={`${this.props.id}__input`}
          onChange={this.handleTimeChange}
          onBlur={this.handleTimeBlur}
          value={this.state.timeInput}
        />
        <Select
          className={cx(s.todSelect, 'schedulingFilter')}
          clearable={false}
          disabled={this.props.disabled}
          id={`${this.props.id}__am_pm_selector`}
          options={this.selectOptions}
          onChange={this.handleTimeOfDayChange}
          searchable={false}
          value={this.state.timeOfDaySelector}
        />
      </div>
    );
  }
}

export default TimeInput;


// WEBPACK FOOTER //
// ./src/components/TimeInput/TimeInput.js